import { useEffect, useState } from 'react';

/**
 * True while a worksheet field holds text it has not committed yet. Fields
 * opt in with `data-committed` (their last committed value); typing makes the
 * report unsaved at once, and blur commits, so focusout clears the flag.
 */
export function useUncommittedText(): boolean {
  const [dirty, setDirty] = useState(false);
  useEffect(() => {
    const onInput = (e: Event) => {
      const el = e.target as HTMLInputElement | HTMLTextAreaElement;
      const committed = el.dataset?.committed;
      setDirty(committed !== undefined && el.value !== committed);
    };
    const onFocusOut = () => setDirty(false);
    document.addEventListener('input', onInput);
    document.addEventListener('focusout', onFocusOut);
    return () => {
      document.removeEventListener('input', onInput);
      document.removeEventListener('focusout', onFocusOut);
    };
  }, []);
  return dirty;
}
